import { render, staticRenderFns } from "./ListOfTransaction.vue?vue&type=template&id=0048401a&scoped=true"
import script from "./ListOfTransaction.vue?vue&type=script&lang=js"
export * from "./ListOfTransaction.vue?vue&type=script&lang=js"
import style0 from "./ListOfTransaction.vue?vue&type=style&index=0&id=0048401a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0048401a",
  null
  
)

export default component.exports